import React from "react";
import icon from "../../assets/treasure.png";

export default function TreasureIcon({ size }) {
  return <img src={icon} width={size} />;
}
